export default (theme) => ({
  appointmentsList: {
    position: 'relative',
    height: '100%',
    overflow: 'hidden',
    '&:before': {
      content: "''",
      width: 2,
      position: 'absolute',
      top: 0,
      left: 101,
      height: '100%',
      borderLeft: '3px solid',
      borderColor: theme.palette.primary.main,
      [theme.breakpoints.down('md')]: {
        left: 61,
      },
      [theme.breakpoints.down('sm')]: {
        left: 21,
      },
    },
  },
  appointmentsWrapper: {
    height: '100%',
    width: '100%',
    overflowY: 'auto',
  },
  loadingInfoCaption: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 20,
      fontSize: 11,
    },
  },
  scrollWrapper: {
    position: 'relative',
    width: '100%',
    padding: '15px 90px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      padding: '15px 30px 15px 50px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: 10,
    },
  },
  checkMarkIcon: {
    width: 15,
    height: 15,
    fill: '#ffffff',
  },
  timeline: {
    margin: 0,
    padding: 0,
  },
  timelineDot: {
    width: 25,
    height: 25,
    margin: 0,
    transform: 'translateY(50px)',
    backgroundColor: theme.palette.background.white,
    position: 'relative',
    zIndex: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      transform: 'translateY(42px)',
    },
  },
  todayTimelineDot: {
    transform: 'translateY(50px) scale(1.4)',
    boxShadow: 'none',
    backgroundColor: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      transform: 'translateY(40px) scale(1.2)',
    },
  },
  pastTimelineDot: {
    boxShadow: 'none',
    backgroundColor: theme.palette.primary.main,
  },
  timelineItem: {
    '&:before': {
      display: 'none',
    },
  },
  timelineConnector: {
    backgroundColor: theme.palette.primary.main,
    height: 120,
    transform: 'translateY(-95px)',
    [theme.breakpoints.down('sm')]: {
      height: 95,
      transform: 'translateY(-78px)',
    },
  },
  timelineContent: {
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
    paddingLeft: 76,
    paddingRight: 0,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 45,
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 15,
      width: 'calc(100% - 20px)',
    },
  },
  appointment: {
    position: 'relative',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: 115,
    border: '1px solid',
    boxSizing: 'border-box',
    padding: '25px 70px 25px 25px',
    borderColor: theme.palette.disabled.main,
    borderRadius: 20,
    transition: 'background .1s linear',
    '&:hover': {
      backgroundColor: `${theme.palette.disabled.main}30`,
    },
    [theme.breakpoints.down('xl')]: {
      padding: '25px 45px 25px 25px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px 40px 16px 13px',
      height: 96,
    },
  },
  dateWrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingRight: 40,
    minWidth: 125,
    borderRight: `1px solid ${theme.palette.disabled.main}`,
    [theme.breakpoints.down('xl')]: {
      paddingRight: 20,
    },
    [theme.breakpoints.down('md')]: {
      minWidth: 90,
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: 10,
      minWidth: 75,
    },
  },
  appointmentStartDate: {
    lineHeight: 1,
    fontWeight: 'bold',
    [theme.breakpoints.down('xl')]: {
      fontSize: 16,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
  appointmentTime: {
    lineHeight: '16px',
    [theme.breakpoints.down('xl')]: {
      fontSize: 11,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 10,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 8,
    },
  },
  infoWrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    width: 'auto',
    [theme.breakpoints.down('xl')]: {
      width: 'calc(100% / 12 * 7)',
    },
  },
  info: {
    textAlign: 'center',
  },
  pastAppointmentInfoWrapper: {
    [theme.breakpoints.down('xl')]: {
      width: 'auto',
    },
  },
  serviceInfoWrapper: {
    width: '100%',
  },
  service: {
    height: '100%',
    paddingLeft: 40,
    width: 'auto',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xl')]: {
      paddingLeft: 20,
    },
    [theme.breakpoints.down('md')]: {
      width: '65%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '80%',
      paddingLeft: 10,
    },
    '& span': {
      [theme.breakpoints.down('xl')]: {
        fontSize: 14,
      },
      [theme.breakpoints.down('md')]: {
        fontSize: 12,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 10,
      },
    },
  },
  healthcareServiceName: {
    textTransform: 'capitalize',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  roomFullName: {
    textTransform: 'capitalize',
    display: 'block',
  },
  providerName: {
    textTransform: 'capitalize',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  controlsWrapper: {
    display: 'flex',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  appointmentConfirmButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 20,
    minWidth: 160,
    width: 'auto',
    height: 45,
    [theme.breakpoints.down('xl')]: {
      minWidth: 130,
      marginLeft: 10,
      height: 40,
    },
    [theme.breakpoints.down('md')]: {
      minWidth: 50,
      width: 32,
      height: 45,
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 32,
      width: 32,
      height: 27,
      margin: 0,
    },
  },
  appointmentConfirmedButton: {
    background: `${theme.palette.primary.main}30`,
  },
  appointmentJoinButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 110,
    height: 45,
    [theme.breakpoints.down('xl')]: {
      minWidth: 90,
      height: 40,
    },
    [theme.breakpoints.down('md')]: {
      minWidth: 50,
      width: 50,
      height: 45,
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 32,
      width: 32,
      height: 27,
      marginBottom: 5,
    },
  },
  joinButtonIcon: {
    minWidth: 23,
    minHeight: 23,
    width: 23,
    height: 23,
    fill: theme.palette.background.white,
    [theme.breakpoints.down('sm')]: {
      minWidth: 17,
      minHeight: 17,
      width: 17,
      height: 17,
    },
  },
  confirmButtonIcon: {
    minWidth: 23,
    minHeight: 23,
    width: 23,
    height: 23,
    fill: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      minWidth: 17,
      minHeight: 17,
      width: 17,
      height: 17,
    },
  },
  controlButtonText: {
    marginLeft: 10,
    lineHeight: 1,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  subMenuButton: {
    position: 'absolute',
    right: 25,
    height: 40,
    width: 40,
    top: '50%',
    transform: 'translateY(-50%)',
    border: 'none',
    background: 'none',
    padding: 0,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > svg': {
      transition: 'fill .2s linear',
    },
    '&:hover > svg': {
      fill: theme.palette.primary.main,
    },
    [theme.breakpoints.down('xl')]: {
      right: 5,
    },
  },
  openedSubMenuButton: {
    zIndex: 1001,
  },
  subMenu: {
    position: 'absolute',
    right: '90%',
    top: '75%',
    borderColor: theme.palette.disabled.main,
    borderRadius: 20,
    backgroundColor: '#ffffff',
    padding: 20,
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    [theme.breakpoints.down('md')]: {
      top: '55%',
    },
  },
  subMenuOverlay: {
    width: '100%',
    height: '100%',
    background: 'transparent',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1001,
  },
  cancellationReasonModalWrapper: {
    position: 'relative',
  },
  appointmentCancellationReasonModal: {
    padding: 40,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 650,
    [theme.breakpoints.down('md')]: {
      minWidth: 'initial',
    },
  },
  cancelButtonIcon: {
    fill: '#FF0000',
    marginRight: 5,
  },
  cancelAppointmentForm: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 20,
    width: '100%',
    margin: '0 auto',
  },
  confirmButton: {
    marginLeft: 20,
    [theme.breakpoints.down('sm')]: {
      margin: '0 0 10px 0',
    },
  },
  statusLabel: {
    marginTop: 8,
  },
  formDescription: {
    padding: '40px 0 0',
  },
  subtitleText: {
    color: theme.palette.font.main,
  },
  formControls: {
    alignSelf: 'flex-end',
    marginTop: 50,
    [theme.breakpoints.down('md')]: {
      alignSelf: 'center',
      marginTop: 30,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column-reverse',
      marginTop: 10,
    },
  },
  mobileIcon: {
    width: 68,
    height: 68,
    objectFit: 'contain',
    objectPosition: 'center',
  },
  modalHeader: {
    textAlign: 'center',
  },
});
